export default __webpack_public_path__ + "static/media/Tilton.585daa5f.jpg";